<template>
    <div>
        <div class="notification-container " v-show="!visible && parceiro.user_id == 7"
            @click="count == 0 ? playNotificationSound : ''; " :class="{ 'tremula': Boolean(count) }">
            <div class="notification-icon" @click="setVisible(true); setIsActive(true); setClient(null)">
                <i class="fas fa-comment-dots fa-lg" style="font-size: 2em;"></i>
                <span v-if="count > 0" class="notification-count tremula">{{ count }}</span>
            </div>
            <div class="notification-content">
                <ul>
                    <li v-for="notification in notifications">{{ notification }}</li>
                </ul>
            </div>
            <audio id="notification-sound">
                <source src="/2189_mobile-rington.mp3" type="audio/mpeg">
            </audio>
        </div>
        <window v-if="visible" @close="setVisible(false)" @minimized="setVisible(false)">
            <ReactFrame v-if="isActive" :cliente_id="client_id"></ReactFrame>
        </window>

    </div>
</template>

<script>
import ReactFrame from "./ReactFrame.vue";
import Window from "../sistema/Window.vue";
import {mapState, mapMutations} from "vuex";
export default {
    components: {
        ReactFrame, Window
    },
    data() {
        return {
            count: 0,
            notifications: []
        };
    },
    computed: {
        ...mapState('user', ['parceiro']),
        ...mapState('chat', ['client_id', 'isActive', 'visible'])
    },
    watch: {
        count(newVal, oldVal) {
            if (newVal > 0 && newVal > oldVal) {
                this.playNotificationSound();
            }
        }
    },
    methods: {
        ...mapMutations('chat', ['setClient','setIsActive', 'setVisible']),
        toggleActive() {
            this.isActive = !this.isActive;
        },
        playNotificationSound() {
            const sound = document.getElementById('notification-sound');
            sound.currentTime = 0;
            sound.play();
        }
    }
};
</script>

<style>
.tremula {
    animation-name: tremula;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
}

@keyframes tremula {
    0% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-3px);
    }

    75% {
        transform: translateX(3px);
    }

    100% {
        transform: translateX(0);
    }
}

.new-notification {
    background-color: red;
    color: white;
}

.notification-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
}

.notification-icon {
    position: relative;
    cursor: pointer;
}

.notification-count {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: red;
    color: white;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-content {
    position: absolute;
    bottom: 40px;
    right: 0;
    width: 200px;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    display: none;
}

.notification-container.active .notification-content {
    display: block;
}
</style>
